/* RAUNAQ Shopify theme — vanilla JS, no dependencies.
   Store data comes from snippets/raunaq-data.liquid as window.RAUNAQ; the bag uses Shopify's AJAX cart API. */
(function () {
  "use strict";
  const R = window.RAUNAQ || { products: [], site: {}, routes: {} };
  const SITE = R.site || {};
  const ROUTES = R.routes || {};
  const PRODUCTS = R.products || [];
  const byHandle = Object.fromEntries(PRODUCTS.map((p) => [p.handle, p]));
  const $ = (s, c) => (c || document).querySelector(s);
  const $$ = (s, c) => Array.from((c || document).querySelectorAll(s));
  const money = (n) => "£" + Number(n).toFixed(2);
  const pence = (n) => money(n / 100);
  const esc = (s) => String(s == null ? "" : s).replace(/[&<>"']/g, (c) => ({ "&": "&amp;", "<": "&lt;", ">": "&gt;", '"': "&quot;", "'": "&#39;" }[c]));
  const thumb = (p) => (p && p.images && p.images[0] ? p.images[0].src : "");
  const WA = SITE.whatsapp_number || "447526583439";
  const waLink = (text) => `https://wa.me/${WA}?text=${encodeURIComponent(text)}`;
  const ALL_SIZES = SITE.all_sizes && SITE.all_sizes.length ? SITE.all_sizes : ["S", "M", "L", "XL"];

  /* ---------- storage (wishlist only; the bag lives in Shopify) ---------- */
  const store = {
    get(k, d) { try { return JSON.parse(localStorage.getItem("raunaq:" + k)) ?? d; } catch (e) { return d; } },
    set(k, v) { try { localStorage.setItem("raunaq:" + k, JSON.stringify(v)); } catch (e) {} },
  };

  /* ---------- toast ---------- */
  let toastTimer;
  function toast(msg, opts = {}) {
    let el = $(".toast");
    if (!el) { el = document.createElement("div"); el.className = "toast"; document.body.appendChild(el); }
    el.innerHTML = (opts.img ? `<img src="${esc(opts.img)}" alt="">` : "") + `<span>${esc(msg)}</span>` + (opts.action ? `<button type="button">${esc(opts.action)}</button>` : "");
    const hide = () => el.classList.remove("is-visible");
    if (opts.action && opts.onAction) el.querySelector("button").onclick = () => { opts.onAction(); hide(); };
    el.classList.add("is-visible");
    clearTimeout(toastTimer);
    toastTimer = setTimeout(hide, opts.duration || 3200);
  }

  /* ---------- announcement rotator ---------- */
  (function announce() {
    const items = $$(".announce__item");
    if (items.length < 2) return;
    let i = 0;
    setInterval(() => { items[i].classList.remove("is-active"); i = (i + 1) % items.length; items[i].classList.add("is-active"); }, 4200);
  })();

  /* ---------- header ---------- */
  (function header() {
    const h = $(".header");
    if (!h) return;
    const on = () => h.classList.toggle("is-scrolled", window.scrollY > 8);
    on(); window.addEventListener("scroll", on, { passive: true });
  })();

  /* ---------- drawers ---------- */
  function openDrawer(id) { const d = $(id); if (!d) return; d.classList.add("is-open"); d.setAttribute("aria-hidden", "false"); document.body.classList.add("no-scroll"); }
  function closeDrawer(id) { const d = $(id); if (!d) return; d.classList.remove("is-open"); d.setAttribute("aria-hidden", "true"); if (!$(".drawer.is-open, .search.is-open, .modal.is-open")) document.body.classList.remove("no-scroll"); }
  document.addEventListener("click", (e) => {
    const o = e.target.closest("[data-open]"); if (o) { e.preventDefault(); openDrawer(o.getAttribute("data-open")); }
    const c = e.target.closest("[data-close]"); if (c) { if (c.tagName !== "A" || c.getAttribute("href") === "#") e.preventDefault(); closeDrawer(c.getAttribute("data-close")); }
    const mt = e.target.closest(".mnav [data-toggle]"); if (mt) { mt.closest("li").classList.toggle("is-open"); }
  });
  document.addEventListener("keydown", (e) => { if (e.key === "Escape") { $$(".drawer.is-open, .search.is-open, .modal.is-open, .lightbox.is-open").forEach((d) => d.classList.remove("is-open")); document.body.classList.remove("no-scroll"); } });

  /* ---------- search ---------- */
  (function search() {
    const box = $("#search"); if (!box) return;
    const input = $("input[type=search]", box), results = $(".search__results", box), empty = $(".search__empty", box);
    $$("[data-search]").forEach((b) => b.addEventListener("click", (e) => { e.preventDefault(); box.classList.add("is-open"); document.body.classList.add("no-scroll"); setTimeout(() => input.focus(), 50); }));
    $$("[data-search-term]", box).forEach((b) => b.addEventListener("click", () => { input.value = b.getAttribute("data-search-term"); run(); }));
    function run() {
      const q = input.value.trim().toLowerCase();
      results.innerHTML = ""; empty.hidden = true;
      if (!q) return;
      const hits = PRODUCTS.filter((p) => [p.name, p.title, p.subtitle, p.fabric, p.work, p.colour, p.pieces ? p.pieces + "-piece " + p.pieces + " piece" : "", ...(p.occasion || [])].join(" ").toLowerCase().includes(q));
      if (!hits.length) { empty.hidden = false; return; }
      hits.forEach((p) => results.insertAdjacentHTML("beforeend", cardHTML(p, { compact: true })));
      bindCards(results); wish.paint();
    }
    input.addEventListener("input", run);
  })();

  /* ---------- wishlist ---------- */
  const wish = {
    list: store.get("wishlist", []),
    has(h) { return this.list.includes(h); },
    toggle(h) { this.has(h) ? (this.list = this.list.filter((x) => x !== h)) : this.list.push(h); store.set("wishlist", this.list); this.paint(); return this.has(h); },
    paint() { $$("[data-wish]").forEach((b) => b.classList.toggle("is-active", this.has(b.getAttribute("data-wish")))); const c = $("[data-wish-count]"); if (c) { c.textContent = this.list.length; c.classList.toggle("is-visible", this.list.length > 0); } },
  };
  document.addEventListener("click", (e) => {
    const b = e.target.closest("[data-wish]"); if (!b) return; e.preventDefault();
    const h = b.getAttribute("data-wish"); const on = wish.toggle(h); const p = byHandle[h];
    toast(on ? `${p ? p.name : "Item"} saved to your wishlist` : `Removed from wishlist`, { img: thumb(p), action: on ? "View" : null, onAction: () => (location.href = ROUTES.wishlist || "/pages/wishlist") });
  });

  /* ---------- sizes / variants ---------- */
  function availableSizes(p) {
    const avail = (p.variants || []).filter((v) => v.available).map((v) => v.size);
    const order = sizeList(p);
    return order.filter((s) => avail.includes(s));
  }
  function sizeList(p) {
    const offered = (p.variants || []).map((v) => v.size);
    const extra = offered.filter((s) => !ALL_SIZES.includes(s));
    return extra.length ? ALL_SIZES.concat(extra.filter((s, i) => extra.indexOf(s) === i)) : ALL_SIZES;
  }
  function variantFor(p, size) { return (p.variants || []).find((v) => v.size === size); }

  /* ---------- cart (Shopify AJAX API) ---------- */
  const cart = {
    state: { items: [], item_count: 0, items_subtotal_price: 0 },
    busy: false,
    async request(url, body) {
      const res = await fetch(url, { method: body ? "POST" : "GET", headers: { "Content-Type": "application/json", Accept: "application/json" }, body: body ? JSON.stringify(body) : undefined });
      const data = await res.json().catch(() => ({}));
      if (!res.ok) throw new Error(data.description || data.message || "Something went wrong");
      return data;
    },
    async refresh() { try { this.state = await this.request(ROUTES.cart_js || "/cart.js"); } catch (e) {} this.paint(); },
    async add(handle, size, qty = 1) {
      const p = byHandle[handle]; if (!p) return false;
      const v = variantFor(p, size);
      if (!v || !v.available) { toast(`Size ${size} is sold out`); return false; }
      try {
        await this.request(ROUTES.cart_add || "/cart/add.js", { items: [{ id: v.id, quantity: qty }] });
      } catch (err) { toast(err.message || "Couldn't add that to your bag"); return false; }
      await this.refresh();
      toast(`${p.name} (${size}) added to your bag`, { img: thumb(p), action: "View bag", onAction: () => openDrawer("#cart") });
      const cnt = $("[data-cart-count]"); if (cnt && cnt.animate) { cnt.animate([{ transform: "scale(1)" }, { transform: "scale(1.35)" }, { transform: "scale(1)" }], { duration: 350 }); }
      return true;
    },
    async setQty(key, qty) {
      if (this.busy) return; this.busy = true;
      try { this.state = await this.request(ROUTES.cart_change || "/cart/change.js", { id: key, quantity: Math.max(0, qty) }); }
      catch (err) { toast(err.message || "Couldn't update your bag"); }
      this.busy = false; this.paint();
    },
    paint() {
      const s = this.state;
      const c = $("[data-cart-count]"); if (c) { c.textContent = s.item_count; c.classList.toggle("is-visible", s.item_count > 0); }
      const body = $("#cart .cart__body"); if (!body) return;
      const foot = $("#cart .cart__foot");
      if (!s.items.length) {
        body.innerHTML = `<div class="cart__empty">${icon("bag")}<h4>Your bag is empty</h4><p>Stitched, UK-stocked and ready in 1–3 days.</p><a class="btn btn--primary" href="${esc(ROUTES.shop || "/collections/all")}" data-close="#cart">Shop new arrivals</a></div>`;
        foot.hidden = true; return;
      }
      body.innerHTML = `<div class="cart__items">` + s.items.map((i) => {
        const p = byHandle[i.handle];
        const name = p ? p.name : i.product_title;
        const sub = p ? p.subtitle : "";
        const size = i.product_has_only_default_variant ? "" : `<small>Size ${esc(i.variant_title)}</small>`;
        const img = i.image ? i.image + (i.image.includes("?") ? "&" : "?") + "width=200" : thumb(p);
        return `
        <div class="cart__item" data-line="${esc(i.key)}">
          <a href="${esc(i.url)}"><img src="${esc(img)}" alt="${esc(name)}"></a>
          <div>
            <b>${esc(name)}</b>${sub ? `<small>${esc(sub)}</small>` : ""}${size}
            <div class="cart__ctrl">
              <div class="qty"><button type="button" data-qty="-1" aria-label="Decrease">−</button><span>${i.quantity}</span><button type="button" data-qty="1" aria-label="Increase">+</button></div>
              <span class="price">${pence(i.final_line_price)}</span>
            </div>
            <button type="button" class="cart__remove" data-remove>Remove</button>
          </div>
        </div>`; }).join("") + `</div>`;
      foot.hidden = false;
      const ship = SITE.shipping || {};
      $("[data-subtotal]", foot).textContent = pence(s.items_subtotal_price);
      const est = deliveryWindow(ship.standard?.min_days || 2, ship.standard?.max_days || 3);
      $("[data-ship-line]", foot).innerHTML = `${icon("truck")}<span>Dispatched from the UK. Standard delivery ${money(ship.standard?.price || 5.99)} · arrives <b>${esc(est)}</b></span>`;
      $("[data-wa-order]", foot).href = waLink(`Assalamualaikum RAUNAQ, I'd like to order:\n` + s.items.map((i) => { const p = byHandle[i.handle]; return `• ${p ? p.name : i.product_title}${i.product_has_only_default_variant ? "" : " – size " + i.variant_title} × ${i.quantity} (${pence(i.final_price)})`; }).join("\n") + `\nSubtotal: ${pence(s.items_subtotal_price)}`);
    },
  };
  document.addEventListener("click", (e) => {
    const q = e.target.closest("#cart [data-qty]"); if (q) { const key = q.closest("[data-line]").getAttribute("data-line"); const l = cart.state.items.find((i) => i.key === key); cart.setQty(key, (l?.quantity || 0) + Number(q.getAttribute("data-qty"))); }
    const r = e.target.closest("#cart [data-remove]"); if (r) { cart.setQty(r.closest("[data-line]").getAttribute("data-line"), 0); }
  });

  /* ---------- delivery estimate (business days) ---------- */
  function addBusinessDays(date, n) { const d = new Date(date); let added = 0; while (added < n) { d.setDate(d.getDate() + 1); const day = d.getDay(); if (day !== 0 && day !== 6) added++; } return d; }
  function fmt(d) { return d.toLocaleDateString("en-GB", { weekday: "short", day: "numeric", month: "short" }); }
  function deliveryWindow(min, max) {
    const now = new Date();
    // dispatch: same day if before the cut-off on a weekday, else next business day
    let dispatch = new Date(now);
    const isWeekday = now.getDay() !== 0 && now.getDay() !== 6;
    if (!(isWeekday && now.getHours() < (SITE.dispatch_cutoff || 14))) dispatch = addBusinessDays(now, 1);
    const a = addBusinessDays(dispatch, min), b = addBusinessDays(dispatch, max);
    return min === max ? fmt(a) : `${fmt(a)} – ${fmt(b)}`;
  }

  /* ---------- product cards (mirror of snippets/product-card.liquid) ---------- */
  function cardHTML(p, opts = {}) {
    const avail = availableSizes(p);
    const sizes = sizeList(p);
    const limited = !p.available ? `<span class="badge badge--limited">Sold out</span>` : avail.length === 1 ? `<span class="badge badge--limited">Only in ${esc(avail[0])}</span>` : "";
    const isNew = (p.badges || []).includes("new") ? `<span class="badge badge--new">New</span>` : "";
    const primary = p.images[0], alt = p.images[1];
    const hover = p.video
      ? `<video class="card__alt" muted loop playsinline preload="none" poster="${esc(p.video.poster)}"><source src="${esc(p.video.src)}" type="video/mp4"></video><span class="card__video-badge">${icon("play")}</span>`
      : alt ? `<img class="card__alt" src="${esc(alt.src900)}" alt="" loading="lazy">` : "";
    return `
    <article class="card" data-handle="${esc(p.handle)}">
      <div class="card__figure">
      <a class="card__media" href="${esc(p.url)}">
        ${primary ? `<img class="card__primary" src="${esc(primary.src)}" srcset="${esc(primary.src)} 480w, ${esc(primary.src900)} 900w" sizes="(max-width:600px) 50vw, (max-width:1100px) 33vw, 25vw" alt="${esc(primary.alt)}" loading="lazy">` : ""}
        ${hover}
        <div class="card__badges">${isNew}${limited}</div>
      </a>
      <button class="card__wish ${wish.has(p.handle) ? "is-active" : ""}" type="button" data-wish="${esc(p.handle)}" aria-label="Save to wishlist">${icon("heart")}</button>
      ${opts.compact ? "" : `<div class="card__sizes">${avail.map((s) => `<span data-quick-size="${esc(s)}">${esc(s)}</span>`).join("")}</div>
      <div class="card__quick"><button class="btn btn--sm" type="button" data-quick-add>Quick add</button></div>
      <div class="sizepop"><p>Select size</p><div class="sizepop__opts">${sizes.map((s) => `<button type="button" data-quick-size="${esc(s)}" ${avail.includes(s) ? "" : "disabled"}>${esc(s)}</button>`).join("")}</div></div>`}
      </div>
      <div class="card__body">
        <h3 class="card__title"><a href="${esc(p.url)}">${esc(p.name)}</a></h3>
        <div class="card__sub">${esc(p.subtitle)}</div>
        <div class="card__row"><span class="card__price">${p.compare_at ? `<s>${money(p.compare_at)}</s>` : ""}${money(p.price)}</span><span class="card__swatches">${(p.swatches || []).map((c) => `<i style="background:${esc(c)}"></i>`).join("")}</span></div>
      </div>
    </article>`;
  }
  function bindCards(scope) {
    $$(".card", scope).forEach((card) => {
      if (card.dataset.bound) return; card.dataset.bound = "1";
      const v = $("video", card);
      if (v) {
        card.addEventListener("mouseenter", () => { v.play().catch(() => {}); });
        card.addEventListener("mouseleave", () => { v.pause(); });
      }
      const quick = $("[data-quick-add]", card), pop = $(".sizepop", card);
      if (quick && pop) {
        quick.addEventListener("click", (e) => {
          e.preventDefault(); const p = byHandle[card.dataset.handle]; if (!p) return;
          const avail = availableSizes(p);
          if (!avail.length) { toast(`${p.name} is sold out`); return; }
          if (avail.length === 1) { cart.add(p.handle, avail[0]); } else { pop.classList.add("is-open"); }
        });
        card.addEventListener("mouseleave", () => pop.classList.remove("is-open"));
      }
      $$("[data-quick-size]", card).forEach((b) => b.addEventListener("click", (e) => { e.preventDefault(); if (b.disabled) return; cart.add(card.dataset.handle, b.getAttribute("data-quick-size")); pop && pop.classList.remove("is-open"); }));
    });
  }
  // wishlist page grid
  $$("[data-grid='wishlist']").forEach((g) => {
    const list = wish.list.map((h) => byHandle[h]).filter(Boolean);
    if (!list.length) { g.innerHTML = `<div class="wishlist-empty"><h2 class="display-md">Nothing saved yet</h2><p>Tap the heart on any suit to keep it here.</p><a class="btn btn--primary" href="${esc(ROUTES.shop || "/collections/all")}">Browse the collection</a></div>`; g.classList.remove("grid"); return; }
    g.innerHTML = list.map((p) => cardHTML(p)).join("");
  });
  bindCards(document);

  /* ---------- shop filters ---------- */
  (function shop() {
    const root = $("[data-shop]"); if (!root) return;
    const grid = $("[data-shop-grid]", root), count = $("[data-count]", root), active = $("[data-active]", root), sort = $("[data-sort]", root);
    const handles = (root.getAttribute("data-handles") || "").split(",").filter(Boolean);
    const POOL = handles.length ? handles.map((h) => byHandle[h]).filter(Boolean) : PRODUCTS;
    if (!POOL.length) return; // nothing to filter; keep the server-rendered grid
    const state = { pieces: [], fabric: [], work: [], size: [], occasion: [], sort: "featured" };
    const q = new URLSearchParams(location.search);
    ["pieces", "fabric", "work", "size", "occasion"].forEach((k) => { if (q.get(k)) state[k] = q.get(k).split(","); });
    if (q.get("sort")) state.sort = q.get("sort");
    if (sort) sort.value = state.sort;
    const label = { pieces: (v) => `${v}-Piece`, fabric: (v) => v, work: (v) => v, size: (v) => `Size ${v}`, occasion: (v) => v };
    const split = (attr) => { const i = attr.indexOf(":"); return [attr.slice(0, i), attr.slice(i + 1)]; };
    function paintControls() {
      $$("[data-filter]", root).forEach((el) => { const [k, v] = split(el.getAttribute("data-filter")); const on = state[k].includes(v); if (el.tagName === "INPUT") el.checked = on; else el.classList.toggle("is-active", on); });
    }
    function apply(first) {
      let list = POOL.filter((p) =>
        (!state.pieces.length || state.pieces.includes(String(p.pieces))) &&
        (!state.fabric.length || state.fabric.includes(p.fabric)) &&
        (!state.work.length || state.work.includes(p.work)) &&
        (!state.size.length || state.size.some((s) => availableSizes(p).includes(s))) &&
        (!state.occasion.length || state.occasion.some((o) => (p.occasion || []).includes(o))));
      if (state.sort === "price-asc") list.sort((a, b) => a.price - b.price);
      if (state.sort === "price-desc") list.sort((a, b) => b.price - a.price);
      if (state.sort === "name") list.sort((a, b) => a.name.localeCompare(b.name));
      const untouched = first && list.length === POOL.length && state.sort === "featured";
      if (!untouched) {
        grid.innerHTML = list.length ? list.map((p) => cardHTML(p)).join("") : `<div class="shop__empty"><h3 class="display-sm">No suits match those filters</h3><p>Try clearing a filter or two, or WhatsApp us and we'll help you find it.</p></div>`;
        bindCards(grid); wish.paint();
      }
      count.textContent = `${list.length} ${list.length === 1 ? "suit" : "suits"}`;
      const chips = []; Object.keys(label).forEach((k) => state[k].forEach((v) => chips.push(`<button class="chip" type="button" data-remove-filter="${esc(k + ":" + v)}">${esc(label[k](v))} ✕</button>`)));
      active.innerHTML = chips.length ? chips.join("") + `<button class="chip" type="button" data-clear-filters>Clear all</button>` : "";
      paintControls();
      const p = new URLSearchParams(); Object.keys(label).forEach((k) => state[k].length && p.set(k, state[k].join(","))); if (state.sort !== "featured") p.set("sort", state.sort);
      history.replaceState(null, "", location.pathname + (p.toString() ? "?" + p : ""));
    }
    root.addEventListener("change", (e) => { const el = e.target.closest("input[data-filter]"); if (!el) return; const [k, v] = split(el.getAttribute("data-filter")); el.checked ? state[k].push(v) : (state[k] = state[k].filter((x) => x !== v)); apply(); });
    root.addEventListener("click", (e) => {
      const chip = e.target.closest("button[data-filter]"); if (chip) { const [k, v] = split(chip.getAttribute("data-filter")); state[k].includes(v) ? (state[k] = state[k].filter((x) => x !== v)) : state[k].push(v); apply(); }
      const rm = e.target.closest("[data-remove-filter]"); if (rm) { const [k, v] = split(rm.getAttribute("data-remove-filter")); state[k] = state[k].filter((x) => x !== v); apply(); }
      if (e.target.closest("[data-clear-filters]")) { Object.keys(label).forEach((k) => (state[k] = [])); apply(); }
      const g = e.target.closest("[data-clear-group]"); if (g) { state[g.getAttribute("data-clear-group")] = []; apply(); }
    });
    sort && sort.addEventListener("change", () => { state.sort = sort.value; apply(); });
    const filters = $(".filters", root);
    $("[data-filters-open]", root)?.addEventListener("click", () => { filters.classList.add("is-open"); document.body.classList.add("no-scroll"); });
    $$("[data-filters-close]", root).forEach((b) => b.addEventListener("click", () => { filters.classList.remove("is-open"); document.body.classList.remove("no-scroll"); }));
    apply(true);
  })();

  /* ---------- product page ---------- */
  (function pdp() {
    const root = $("[data-pdp]"); if (!root) return;
    const p = byHandle[root.getAttribute("data-pdp")];
    const form = $("[data-product-form]", root);
    const sizeBtns = $$(".size", root), addBtn = $("[data-add]", root), qtyEl = $("[data-qty-val]", root), waBtn = $("[data-wa-product]", root), stickyAdd = $("[data-sticky-add]");
    const variantInput = $("[data-variant-input]", root);
    let size = null, qty = 1;
    const avail = p ? availableSizes(p) : [];
    if (avail.length === 1) size = avail[0];
    const name = p ? p.name : ($("h1", root)?.textContent || "");
    function paint() {
      sizeBtns.forEach((b) => b.classList.toggle("is-active", b.getAttribute("data-size") === size));
      const lbl = $("[data-size-label]", root); if (lbl) lbl.textContent = size ? `Selected: ${size}` : "Select a size";
      if (qtyEl) qtyEl.textContent = qty;
      const v = p && size ? variantFor(p, size) : null;
      if (v && variantInput) variantInput.value = v.id;
      if (addBtn && p && p.available) addBtn.textContent = size ? `Add to bag · ${money((v ? v.price : p.price) * qty)}` : "Select a size";
      if (waBtn) waBtn.href = waLink(`Assalamualaikum RAUNAQ, I'm interested in ${name}${p && p.subtitle ? " (" + p.subtitle + ")" : ""}${size ? " in size " + size : ""} – ${location.origin}${location.pathname} . Is it available?`);
    }
    sizeBtns.forEach((b) => b.addEventListener("click", () => {
      const s = b.getAttribute("data-size");
      if (b.classList.contains("is-soldout")) { toast(`Size ${s} is sold out. WhatsApp us to be notified when it's back.`, { action: "WhatsApp", onAction: () => window.open(waLink(`Hi RAUNAQ, please let me know when ${name} is back in size ${s}.`)) }); return; }
      size = s; paint();
    }));
    $$("[data-qty-step]", root).forEach((b) => b.addEventListener("click", () => { qty = Math.max(1, qty + Number(b.getAttribute("data-qty-step"))); paint(); }));
    const doAdd = async (e) => {
      if (e) e.preventDefault();
      if (!p) { form && form.submit(); return; }
      if (!size) { toast("Please choose a size first"); const el = $(".sizes", root); el && el.animate && el.animate([{ transform: "translateX(0)" }, { transform: "translateX(-4px)" }, { transform: "translateX(4px)" }, { transform: "translateX(0)" }], { duration: 300 }); return; }
      if (addBtn) addBtn.disabled = true;
      const ok = await cart.add(p.handle, size, qty);
      if (addBtn) addBtn.disabled = false;
      if (ok) openDrawer("#cart");
    };
    form && form.addEventListener("submit", doAdd);
    stickyAdd && stickyAdd.addEventListener("click", doAdd);
    // delivery estimates
    const ship = SITE.shipping || {};
    const es = $("[data-est-standard]", root), ex = $("[data-est-express]", root);
    if (es) es.textContent = deliveryWindow(ship.standard?.min_days || 2, ship.standard?.max_days || 3);
    if (ex) ex.textContent = deliveryWindow(ship.express?.min_days || 1, ship.express?.max_days || 2);
    // gallery
    const slides = $$(".gallery__main .slide", root), thumbs = $$(".gallery__thumbs button", root), dots = $$(".gallery__dots i", root);
    let idx = 0;
    function go(n) { if (!slides.length) return; idx = (n + slides.length) % slides.length; slides.forEach((s, i) => { s.classList.toggle("is-active", i === idx); if (s.tagName === "VIDEO") i === idx ? s.play().catch(() => {}) : s.pause(); }); thumbs.forEach((t, i) => t.classList.toggle("is-active", i === idx)); dots.forEach((d, i) => d.classList.toggle("is-active", i === idx)); }
    thumbs.forEach((t, i) => t.addEventListener("click", () => go(i)));
    $("[data-gal-prev]", root)?.addEventListener("click", () => go(idx - 1));
    $("[data-gal-next]", root)?.addEventListener("click", () => go(idx + 1));
    let sx = 0; const main = $(".gallery__main", root);
    if (main) {
      main.addEventListener("touchstart", (e) => (sx = e.touches[0].clientX), { passive: true });
      main.addEventListener("touchend", (e) => { const dx = e.changedTouches[0].clientX - sx; if (Math.abs(dx) > 40) go(idx + (dx < 0 ? 1 : -1)); });
    }
    // zoom: open the largest rendition of the current image
    const lb = $(".lightbox");
    $("[data-zoom]", root)?.addEventListener("click", () => {
      const s = slides[idx]; if (!s || s.tagName !== "IMG") return;
      const full = (s.currentSrc || s.src).replace(/([?&])width=\d+/, "$1width=2000");
      $("img", lb).src = full; lb.classList.add("is-open");
    });
    lb && $("[data-lb-close]", lb).addEventListener("click", () => lb.classList.remove("is-open"));
    lb && lb.addEventListener("click", (e) => { if (e.target === lb) lb.classList.remove("is-open"); });
    // sticky bar
    const sticky = $(".sticky-buy");
    if (sticky && addBtn && "IntersectionObserver" in window) { const io = new IntersectionObserver(([en]) => { sticky.classList.toggle("is-visible", !en.isIntersecting); document.body.classList.toggle("has-sticky", !en.isIntersecting); }, { threshold: 0 }); io.observe(addBtn); }
    paint();
  })();

  /* ---------- accordions ---------- */
  document.addEventListener("click", (e) => { const b = e.target.closest(".acc__btn"); if (!b) return; const item = b.closest(".acc__item"); const group = item.closest(".acc"); if (group && group.hasAttribute("data-single")) $$(".acc__item", group).forEach((i) => i !== item && i.classList.remove("is-open")); item.classList.toggle("is-open"); b.setAttribute("aria-expanded", item.classList.contains("is-open")); });

  /* ---------- size guide: unit toggle + modal ---------- */
  (function sizeGuide() {
    document.addEventListener("click", (e) => {
      const btn = e.target.closest("[data-unit]"); if (!btn) return;
      const unit = btn.getAttribute("data-unit"); const wrap = btn.closest("[data-sizeguide]");
      $$("[data-unit]", wrap).forEach((b) => b.classList.toggle("is-active", b === btn));
      $$("[data-in]", wrap).forEach((td) => { const v = Number(td.getAttribute("data-in")); if (!isNaN(v)) td.textContent = unit === "cm" ? Math.round(v * 2.54) : v; });
      $$("[data-unit-label]", wrap).forEach((el) => (el.textContent = unit === "cm" ? "cm" : "inches"));
    });
    document.addEventListener("click", (e) => {
      const b = e.target.closest("[data-modal]"); if (b) { e.preventDefault(); const m = $(b.getAttribute("data-modal")); if (m) { m.classList.add("is-open"); document.body.classList.add("no-scroll"); } return; }
      const c = e.target.closest(".modal [data-modal-close], .modal .modal__scrim"); if (c) { c.closest(".modal").classList.remove("is-open"); document.body.classList.remove("no-scroll"); }
    });
  })();

  /* ---------- reveal on scroll ---------- */
  (function reveal() {
    const els = $$(".reveal"); if (!els.length || !("IntersectionObserver" in window)) { els.forEach((e) => e.classList.add("is-in")); return; }
    const io = new IntersectionObserver((ents) => ents.forEach((en) => { if (en.isIntersecting) { en.target.classList.add("is-in"); io.unobserve(en.target); } }), { rootMargin: "0px 0px -8% 0px" });
    els.forEach((e) => io.observe(e));
    // the theme editor re-renders sections; show them straight away there
    if (window.Shopify && window.Shopify.designMode) els.forEach((e) => e.classList.add("is-in"));
  })();

  /* ---------- reels autoplay when visible ---------- */
  (function reels() {
    const vids = $$(".reel video, .hero__frame video");
    if (vids.length && "IntersectionObserver" in window) {
      const io = new IntersectionObserver((ents) => ents.forEach((en) => { en.isIntersecting ? en.target.play().catch(() => {}) : en.target.pause(); }), { threshold: 0.25 });
      vids.forEach((v) => io.observe(v));
    }
    $$("[data-mute]").forEach((b) => b.addEventListener("click", () => { const v = $("video", b.parentElement); if (!v) return; v.muted = !v.muted; b.innerHTML = v.muted ? icon("mute") : icon("sound"); }));
  })();

  /* ---------- icons ---------- */
  function icon(n) {
    const s = 'xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"';
    const paths = {
      heart: '<path d="M20.8 4.6a5.5 5.5 0 0 0-7.8 0L12 5.6l-1-1a5.5 5.5 0 0 0-7.8 7.8l1 1L12 21l7.8-7.6 1-1a5.5 5.5 0 0 0 0-7.8z"/>',
      play: '<path d="M6 4l14 8-14 8z" fill="currentColor" stroke="none"/>',
      bag: '<path d="M6 7h12l1 14H5z"/><path d="M9 7a3 3 0 0 1 6 0"/>',
      truck: '<path d="M3 7h11v9H3z"/><path d="M14 10h4l3 3v3h-7z"/><circle cx="7" cy="18" r="1.6"/><circle cx="17" cy="18" r="1.6"/>',
      mute: '<path d="M11 5L6 9H3v6h3l5 4z"/><path d="M22 9l-6 6M16 9l6 6"/>',
      sound: '<path d="M11 5L6 9H3v6h3l5 4z"/><path d="M15.5 8.5a5 5 0 0 1 0 7M18.5 5.5a9 9 0 0 1 0 13"/>',
    };
    return `<svg ${s}>${paths[n] || ""}</svg>`;
  }

  wish.paint();
  cart.refresh();
  // keep the bag in sync when returning via the back button
  window.addEventListener("pageshow", (e) => { if (e.persisted) cart.refresh(); });
})();
